module.exports = __webpack_public_path__ + "img/thumb3.0cc2018a.png";